// extracted by mini-css-extract-plugin
export default {"chipContainer":"DeviceStatusSummaryCell_chipContainer__DxWuC","deviceStatusChip":"DeviceStatusSummaryCell_deviceStatusChip__fJiNX"};